// import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./Styles.css";
// import { FaGooglePlay, FaApple } from "react-icons/fa";

// export default function HeroSection() {
//   const headingWords = [
//     "India’s",
//     "First",
//     "AI",
//     <span className="companion">Companion</span>,
//     <span className="companion">App</span>,
//   ];
//   const [adopters, setAdopters] = useState(0);

//   // Fetch initial count from Django
//   const images = [
//     require("../assets/image1.jpeg"),
//     require("../assets/image2.jpeg"),
//     require("../assets/image3.jpeg"),
//     require("../assets/image3.jpeg"),
//   ];
//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//   const fetchAdopters = async () => {
//     try {
//       const res = await fetch("http://127.0.0.1:8000/contact/adopters/");
//       const data = await res.json();
//       console.log("Fetched adopter data:", data);  // 🔹 Add this
//       setAdopters(data.count); // update state
//     } catch (error) {
//       console.error("Error fetching adopters:", error);
//     }
//   };
//   fetchAdopters();
// }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % images.length);
//     }, 4000);
//     return () => clearInterval(interval);
//   }, []);

//   const handleButtonClick = async (url) => {
//   window.open(url, "_blank", "noopener,noreferrer");
//   try {
//     const res = await fetch("http://127.0.0.1:8000/contact/adopters/", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ user_id: "guest", platform: "web" }),
//     });
//     const data = await res.json();
//     setAdopters(data.count);
//   } catch (error) {
//     console.error("Error updating adopters:", error);
//   }
// };

//   return (
//     <div className="container-fluid hero-container py-5">
//       <div className="row justify-content-center align-items-center">
//         <div className="col-lg-6 px-4 text-white hero-text">
//           <h1 className="hero-heading">
//             {headingWords.map((word, idx) => (
//               <span key={idx} style={{ "--i": idx }}>
//                 {word}&nbsp;
//               </span>
//             ))}
//           </h1>
//           <p className="hero-subheading mt-3">
//             Talk in your language. Call when you need to be heard. <br />
//             Guftagu listens, remembers, and responds like a friend—24/7. <br />
//             Pre-register today for exclusive early access.
//           </p>

//           <div className="d-flex gap-3 mt-4">
//             <button
//               className="icon-btn"
//               onClick={() =>
//                 handleButtonClick("https://apps.apple.com/app/your-app-id")
//               }
//             >
//               <FaApple className="icon" />
//               <span className="hover-text">App Store</span>
//             </button>

//             <button
//               className="icon-btn"
//               onClick={() =>
//                 handleButtonClick(
//                   "https://play.google.com/store/apps/details?id=com.guftagu.app&hl=en"
//                 )
//               }
//             >
//               <FaGooglePlay className="icon" />
//               <span className="hover-text">Google Play</span>
//             </button>
//           </div>

//           <p className="early-text mt-4">
//             🚀 Join{" "}
//             <b className="companion">{(3000 + adopters).toLocaleString()}</b>{" "}
//             early adopters who have already secured their spot!
//           </p>
//         </div>

// <div className="col-lg-4 text-center futuristic-gallery">
//     <div className="futuristic-frame">

//     {images.map((src, index) => (
//       <img
//         key={index}
//         src={src}
//         alt="App preview"
//         className={`gallery-image ${index === currentIndex ? "active" : ""}`}
//       />
//     ))}
//   </div>
// </div>
// </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles.css";
import { FaGooglePlay, FaApple } from "react-icons/fa";

export default function HeroSection() {
  const headingWords = [
    "India’s",
    "First",
    "AI",
    <span className="companion">Companion</span>,
    <span className="companion">App</span>,
  ];
  const [adopters, setAdopters] = useState(0);

  // Fetch initial count from Django
  // useEffect(() => {
  //   const fetchAdopters = async () => {
  //     try {
  //       const res = await fetch("");
  //       const data = await res.json();
  //       setAdopters(data.count);
  //     } catch (error) {
  //       console.error("Error fetching adopters:", error);
  //     }
  //   };
  //   fetchAdopters();
  // }, []);

  // const handleButtonClick = async (url) => {
  //   window.open(url, "_blank", "noopener,noreferrer");
  //   try {
  //     const res = await fetch("", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ user_id: "guest", platform: "web" }),
  //     });
  //     const data = await res.json();
  //     setAdopters(data.count);
  //   } catch (error) {
  //     console.error("Error updating adopters:", error);
  //   }
  // };
  useEffect(() => {
  const fetchAdopters = async () => {
    try {
      const res = await fetch("https://landing.guftagu.net/contact/adopters/");
      const data = await res.json();
      console.log("Fetched adopter data:", data);  // 🔹 Add this
      setAdopters(data.count); // update state
    } catch (error) {
      console.error("Error fetching adopters:", error);
    }
  };
  fetchAdopters();
}, []);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex((prev) => (prev + 1) % images.length);
  //   }, 4000);
  //   return () => clearInterval(interval);
  // }, []);

  const handleButtonClick = async (url) => {
  window.open(url, "_blank", "noopener,noreferrer");
  try {
    const res = await fetch("https://landing.guftagu.net/contact/adopters/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id: "guest", platform: "web" }),
    });
    const data = await res.json();
    setAdopters(data.count);
  } catch (error) {
    console.error("Error updating adopters:", error);
  }
};

  return (
    <div className="container-fluid hero-container">
      <div className="row justify-content-center align-items-center">
        <div className="col-lg-6 px-4 text-white hero-text">
          <h1 className="hero-heading">
            {headingWords.map((word, idx) => (
              <span key={idx} style={{ "--i": idx }}>
                {word}&nbsp;
              </span>
            ))}
          </h1>
          {/* <p className="hero-subheading mt-3">
            Talk in your language. Call when you need to be heard. <br />
            gupsy listens, remembers, and responds like a friend—24/7. <br />
            Download now and start the conversation.
          </p> */}
          <p className="hero-subheading mt-3">
             Talk in your language. Call when you need to be heard. <br />
             gupsy listens, remembers, and responds like a friend—24/7. <br />
             Pre-register today for exclusive early access.
           </p>
          {/* <div className="d-flex gap-3 mt-4">
            <button
              className="icon-btn"
              
            >
              <FaApple className="icon" />
              <span className="hover-text">App Store</span>
            </button>

            <button
              className="icon-btn"
              onClick={() =>
                handleButtonClick(
                  "https://play.google.com/store/apps/details?id=com.guftagu.app&hl=en"
                )
              }
            >
              <FaGooglePlay className="icon" />
              <span className="hover-text">Google Play</span>
            </button>
          </div> */}

          {/* <p className="early-text mt-4">
            🚀 Join{" "}
            <b className="companion">{(3000 + adopters).toLocaleString()}</b>{" "}
            early adopters who have already secured their spot!
          </p> */}
        {/* </div> */}
        <div className="d-flex gap-3 mt-4">
             <button
              className="icon-btn"
              onClick={() =>
                handleButtonClick("https://apps.apple.com/app/your-app-id")
              }
            >
              <FaApple className="icon" />
              <span className="hover-text">App Store</span>
            </button>

            <button
              className="icon-btn"
              onClick={() =>
                handleButtonClick(
                  "https://play.google.com/store/apps/details?id=com.gupsy.ai"
                )
              }
            >
              <FaGooglePlay className="icon" />
              <span className="hover-text">Google Play</span>
            </button>
          </div>

          <p className="early-text mt-4">
            🚀 Join{" "}
            <b className="companion">{(3400 + adopters).toLocaleString()}</b>{" "}
            early adopters who have already secured their spot!
          </p>
        </div>

        <div className="col-lg-4 text-center gif-container">
          {/* <div className="neon-frame"> */}
          <img
            src={require("../assets/Image_20251006_163923_882.gif")}
            alt="App Animation"
            className="hero-gif"
          />
        </div>
        {/* </div> */}
        {/* <div className="col-lg-4 text-center animation-container">
          <div className="holo-card">
            <img
              src={require("../assets/Image_20251006_163923_882.gif")}
              alt="App Animation"
              className="holo-gif"
            />
            <div className="holo-lines">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
